import { Component, Injector, ElementRef, Inject } from "@angular/core";
import { CommonChartToolBar } from "../commonChartToolBar/commonChartToolBar.component";
import { CookiesService } from "../../tools/cookies.service";
import * as $ from "jquery";
import { UserType } from "../../enums/USerType.enum";
import { ShowUserProfileModal } from "../modals/userProfile/show-user-profile-modal";
import { ShowProviderConnectionModal } from "../modals/providerConnection/show-provider-connection-modal";
import { challengesHistoryModal } from "../modals/challengesHistory/challengesHistory.component";
import { DataService } from "../../services/data/data.service";
import { WorkspaceServiceService } from "../../services/workspace-service.service";
import { GlobalGridModeService } from "../../services/globalGridMode/globalGridMode.service";
import { ChartLayoutModeService } from "../../services/chartLayoutMode/chartLayoutMode.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ChartInstanceService } from "../../services/chartInstance/chart.instance.service";
import { spaceAfterDataService } from "../../services/spaceAfterDataService/spaceAfterData.service";
import { SettingsClient, Account } from "../../api/DixApiClient";
import { HttpClient } from "@angular/common/http";
import { showScannerTrialPopupModal } from "../scanner/modals/ScannerTrialPopup/show-ScannerTrialPopup-modal";
import { getPeriodCss } from '../../interfaces/historyItem';
import * as moment from "moment";
import { showScannerTrialReminderModal } from "../scanner/modals/ScannerTrialReminder/show-ScannerTrialReminder-modal";
import {Providers} from "../../enums/providers";

@Component( {
    selector: "nav-menu",
    template: require('./navmenu.component.html'),
    styles: [ require('./navmenu.component.css') ]
} )
export class NavMenuComponent extends CommonChartToolBar {

    userProviders: any[] = [];
    httpClient: HttpClient;

    constructor (
        chartInstanceService: ChartInstanceService,
        modalService: NgbModal,
        element: ElementRef,
        activeLayoutTypeService: ChartLayoutModeService,
        globalGridService: GlobalGridModeService,
        spaceAfterDataService: spaceAfterDataService,
        workspaceService: WorkspaceServiceService,
        injector: Injector,
        dataService: DataService,
        @Inject( HttpClient ) http: HttpClient
    ) {
        super( chartInstanceService, modalService, element, activeLayoutTypeService, globalGridService, spaceAfterDataService, workspaceService, injector );

        this.httpClient = http;

    }

    // ngAfterViewInit () {
    //     setTimeout( () => {
    //         let settingClient: SettingsClient = new SettingsClient( this.httpClient );
    //         settingClient.getProviders( this.workspaceService.data.userId ).subscribe( data => {
    //             this.userProviders = data;
    //         } );
    //     }, 5000 );

    // }

    // constructor (
    //     constructor(
    //         public chartInstanceService: ChartInstanceService,
    //         public modalService: NgbModal,
    //         public element: ElementRef,
    //         private activeLayoutTypeService: ChartLayoutModeService,
    //         public globalGridService: GlobalGridModeService,
    //         private spaceAfterDataService: spaceAfterDataService,
    //         public workspaceService: WorkspaceServiceService,
    //         injector: Injector,
    //     )
    //     protected dataService: DataService ) {
    //     super( chartInstanceService, modalService, element, activeLayoutTypeService, globalGridService, spaceAfterDataService, workspaceService, injector );
    // }

    get isOandaProvider (): boolean {
        return this.userProviders.find( x => x.providerId == "OANDA" ) != undefined;

    }

    get liveAccount (): boolean {
        return this.dataService.LiveAccount;
    }

    set showGrid ( v: boolean ) {
        this.workspaceService.data.showPeriod = v;
    }

    get showGrid (): boolean {
        return this.workspaceService.data.showPeriod;
    }

    set showLastPriceIndicator ( value: boolean ) {
        this.workspaceService.data.showCurrentRate = value;
    }

    get showLastPriceIndicator (): boolean {
        return this.workspaceService.data.showCurrentRate;
    }

    set showTradeLines ( value: boolean ) {
        this.workspaceService.data.showtradeLines = value;
    }

    get showTradeLines (): boolean {
        return this.workspaceService.data.showtradeLines;
    }

    get currentProvider (): string {
        return this.workspaceService.data.currentProvider;
    }

    public get showIndicatorLines (): boolean {
        return this.workspaceService.data.showIndicatorLines;
    }
    public set showIndicatorLines ( value: boolean ) {
        this.workspaceService.data.showIndicatorLines = value;
    }
    //   private

    set lockAllCharts ( value: boolean ) {
        this.workspaceService.data.lockAllCharts = value;
    }

    get lockAllCharts (): boolean {
        return this.workspaceService.data.lockAllCharts;
    }

    public changeGlobalGridMode () {
        console.log( "GRID" );
        this.showGrid == false ? ( this.showGrid = true ) : ( this.showGrid = false );
    }

    public toggleLastPriceIndicator () {
        this.showLastPriceIndicator = !this.showLastPriceIndicator;
    }

    public toggleTradeLines () {
        this.showTradeLines = !this.showTradeLines;
    }

    public toggleIndicatorLines () {
        this.showIndicatorLines = !this.showIndicatorLines;
    }

    public toggleLockAllCharts () {
        this.lockAllCharts = !this.lockAllCharts;
    }

    public logoutAction () {
        //alert("123");
        //    this.cookieService.deleteCookie("_r");
        //     this.cookieService.deleteCookie("_xu");
        window.location.href = "/";
        this.cookieService.deleteCookie( "_zp" );
    }

    public toggleMobileMode () {
        this.mobileEnabled = !this.mobileEnabled;
    }

    private _mobileEnabled: boolean = false;
    public get mobileEnabled (): boolean {
        return this.workspaceService.data.mobileMode == "desktop" ? false : true;
    }

    public set mobileEnabled ( value: boolean ) {
        this._mobileEnabled = value;

        if ( value == true ) {
            this.workspaceService.data.mobileMode = "phone";
        } else {
            this.workspaceService.data.mobileMode = "desktop";
        }
    }



    public toggleEndSerieMode () {
        this.endSerie = !this.endSerie;
    }

    private _endSerie: boolean = false;
    public get endSerie (): boolean {
        return this.workspaceService.data.addPointsForWzard
    }

    public set endSerie ( value: boolean ) {
        this._mobileEnabled = value;

        if ( value == true ) {
            this.workspaceService.data.addPointsForWzard = true;
        } else {
            this.workspaceService.data.addPointsForWzard = false;
        }
    }




    public refreshAction()
    {
        this.workspace.refreshAction();
    }

    public scannerPopup()
    {
        //showScannerTrialPopupModal(this.modalService, this.workspace.mobileMode);
        this.globaGridMode.registrationScanner.next(true);
    }

    public get sca()
    {
        return this.dataService.AllowScannerAccess;
    }




    public get allowOpenAccount (): boolean {
        return true; //( this.workspaceService.data.userType == UserType.Regular );
    }

    public togglecompetitionMode () {
        this.competitionEnabled = !this.competitionEnabled;
    }

    private _competitionEnabled: boolean = false;
    public get competitionEnabled (): boolean {
        return this.workspace.isActiveCompetition;
    }
    public set competitionEnabled ( value: boolean ) {
        this.workspace.isActiveCompetition = value;
    }

    public showUserProfileModal () {
        ShowUserProfileModal( this.modalService, this.workspace.mobileMode );
    }

    public showChallengesHistory () {
        challengesHistoryModal( this.modalService );
    }

    public showLoginModal () {
        if ( !this.workspaceService.data.LoginModalCreated ) {
            ShowProviderConnectionModal( this.modalService, this.workspace.mobileMode );
        }
    }

    public switchProvider ( provider: Providers ) {
        if ( provider == Providers.DEMO || provider == Providers.OANDA ) {
            this.dataService.switchProvider( provider ).then( data => {
                console.log( data );

                if ( provider == Providers.OANDA ) {
                    let accounts: Account[] = [];

                    ( data as any[] ).forEach( ( item, index ) => {
                        accounts.push( new Account( { id: index, accountName: item.AccountName, balance: item.Balance, pnL: item.PnL } ) );
                    } );

                    this.workspaceService.data.accounts = accounts;
                    if ( accounts.length > 0 ) {
                        this.workspaceService.data.activeAccountId = 0;
                    }
                } else if ( provider == Providers.DEMO ) {
                    this.workspaceService.data.AccountsClient.getAllByEmail( this.workspaceService.data.userName ).subscribe( d => {
                        this.workspaceService.data.accounts = d;
                        if ( d.length > 0 ) {
                            this.workspaceService.data.activeAccountId = d[ 0 ].id;
                        }
                    } );
                }


                this.workspaceService.data.currentProvider = provider;
            } ).catch( error => {
                console.log( error );
            } );

        }
    }

    public setDateToTrialEnd(val:number)
    {
        let now = moment().utc();
        let endDate = now.subtract("days",val).utc();

        let cookieName: string = "starScannerTrial"; // + this.competition.id;
     
        this.cookieService.setCookie(cookieName, endDate.format("YYYY-MM-DD"), 30, "/");

    }


    public reminderPopup()
    {
        showScannerTrialPopupModal(this.modalService, this.workspace, this.workspace.mobileMode);
      //  showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
     //   this.globaGridMode.appSuccessNotification.next("IMAGE");
    }

}
